import { createSlice, createAsyncThunk, createEntityAdapter, } from '@reduxjs/toolkit';
import { client } from '../api/client';
import { RootState } from '../app/store';
import { Log } from '../models/log';
import { PaginatedResult } from '../models/paginatedResult';

const logAdapter = createEntityAdapter<Log>({
  //sortComparer: (a, b) => b.id > a.id ? -1 : 1,
});

type LogState = {
  status: 'idle' | 'succeeded' | 'loading' | 'failed',
  error?: string,
  nextPage?: string;
  count: number;

  entityId?: string | number;
  logUrl?: string;
}

const initialState = logAdapter.getInitialState<LogState>({
  status: 'idle',
  count: 0,
});

type ThunkArg = {
  nextPage?: string;
  logUrl: string;
  id: string | number;
};

export const fetchLogs = createAsyncThunk<PaginatedResult<Log>, ThunkArg>('log/fetchLog',
  async (payload) => {
    const response = await client.get(payload?.nextPage ?? `${payload?.logUrl}/logg`);
    return response;
  });


const logSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {
    refresh: () => initialState,
  },

  extraReducers: builder => builder
    .addCase(fetchLogs.pending, (state, action) => {
      if (state?.entityId !== action.meta.arg?.id || state?.logUrl !== action.meta.arg?.logUrl) {
        logAdapter.removeAll(state);
        state.count = 0;
        state.entityId = action.meta.arg?.id;
        state.logUrl = action.meta.arg?.logUrl;
      }
      state.nextPage = undefined;
      state.status = 'loading';
    })
    .addCase(fetchLogs.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.count = action.payload.count;
      state.nextPage = action.payload?.nextPage;
      logAdapter.upsertMany(state, action.payload?.value);
    })
    .addCase(fetchLogs.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })
});

export default logSlice.reducer;

export const {
  refresh
} = logSlice.actions;

export const {
  selectAll: selectAllLogs,
  selectById: selectLogById
} = logAdapter.getSelectors((state: RootState) => state?.log);
